import { render, staticRenderFns } from "./dialogPlus.vue?vue&type=template&id=1a921a7d&"
import script from "./dialogPlus.vue?vue&type=script&lang=js&"
export * from "./dialogPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports